import { cn } from "@/lib/utils";

export default function LoadingAnimation({
  className,
  ...props
}: React.ComponentProps<"img">) {
  return (
    <img
      alt="Loading..."
      className={cn("m-auto size-[150px]", className)}
      src="/images/pixel_square_loader.webp"
      {...props}
    />
  );
}
